export default __webpack_public_path__ + "static/media/Group 3198@2x.f321cca5.png";